/*--------------------
* Light / dark switch
----------------------*/
export default function ThemeToggle({ theme, onToggle, className = '' }) {
  const isLight = theme === 'light';

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`group relative flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-tint/[.14] bg-tint/[.03] text-chalk transition-all duration-300 hover:border-tint/30 hover:bg-tint/[.08] ${className}`}
      aria-label={`Switch to ${isLight ? 'dark' : 'light'} theme`}
      title={`Switch to ${isLight ? 'dark' : 'light'} theme`}
    >
      {/* Sun and moon are stacked and cross-faded so the button never jumps. */}
      <svg
        className={`absolute h-[17px] w-[17px] transition-all duration-300 ${
          isLight ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-50 opacity-0'
        }`}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="4.2" />
        <path d="M12 2.4v2.2M12 19.4v2.2M4.2 12H2M22 12h-2.2M5.6 5.6 7.2 7.2M16.8 16.8l1.6 1.6M18.4 5.6 16.8 7.2M7.2 16.8l-1.6 1.6" />
      </svg>

      <svg
        className={`absolute h-[17px] w-[17px] transition-all duration-300 ${
          isLight ? 'rotate-90 scale-50 opacity-0' : 'rotate-0 scale-100 opacity-100'
        }`}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M20.5 14.3A8.5 8.5 0 0 1 9.7 3.5a8.5 8.5 0 1 0 10.8 10.8Z" />
      </svg>
    </button>
  );
}
